import * as React from 'react';
import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { Link } from '@atlassian/help-center-common-component/analytics';
import { Button } from '@atlassian/help-center-common-component/analytics/button';
import type { ButtonProps } from '@atlassian/help-center-common-component/analytics/button';

export const HEADER_HEIGHT = grid.unitless * 7;
// Nav line height set to 0 so it is correctly vertically aligned.
const NAV_LINE_HEIGHT = 0;

// eslint-disable-next-line rulesdir/no-styled-export
export const Root = styled.header<{ isAdvancedHelpCenter: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: ${token('space.100', '8px')};
    padding-right: ${token('space.100', '8px')};
    height: ${HEADER_HEIGHT}px;
    overflow: hidden;
    ${(props) => {
        return props.isAdvancedHelpCenter ? `background-color: ${props.theme.color}` : '';
    }}
`;

interface PortalLinkProps {
    logoTextColor: 'banner' | 'theme';
}

export const PortalLink = styled<React.ComponentProps<typeof Link> & PortalLinkProps>(({ logoTextColor, ...props }) => (
    <Link {...props} />
)).attrs({
    className: 'cv-exclude-from-customisation',
})`
    /* stylelint-disable scale-unlimited/declaration-strict-value */
    color: ${(props) =>
        props.logoTextColor === 'banner' ? props.theme.titleColor : token('color.link', props.theme.color)};

    &:hover {
        color: ${(props) =>
            props.logoTextColor === 'banner' ? props.theme.titleColor : token('color.link', props.theme.color)};
    }
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const Nav = styled.nav`
    /* Ensures header icons are vertically aligned consistently accross browsers */
    line-height: ${NAV_LINE_HEIGHT};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const NavList = styled.ul`
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
`;

// We need to override this because ADG button is transparent and not actually grey.
// This makes sure you can see the button against the banner.
// eslint-disable-next-line rulesdir/no-styled-export
export const ExternalNavLink = styled.div`
    ${mixins.subtleThemeColorBackground};
    border: 2px ${token('color.border.inverse', colors.N0)} solid;
    border-radius: ${grid.multiple(2).px};
    margin-left: ${token('space.100', '8px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const NavItem = styled.li`
    display: inline;
    margin: 0;
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const LoginButton = styled((props: Omit<ButtonProps, 'theme'>) => <Button {...props} />)`
    && {
        padding-left: ${token('space.150', '12px')};
        padding-right: ${token('space.150', '12px')};
    }
`;
